import { PanelShell, Badge, ApiResourceView, DJSEMApiClient, useApiResource } from "../index";

interface BookingItem { id: string; title: string; status: string; eventDate?: string; }

/**
 * Gigs module — lists the user's event bookings with their status (confirmed/cancelled/etc.)
 * so they can track gig prep at a glance.
 *
 * @param client - The API client used to fetch the bookings list.
 * @returns A panel of bookings with status badges (or the loading/error/empty view).
 */
export function GigsModule({ client }: { client: DJSEMApiClient }) {
  const res = useApiResource(() => client.listBookings(), [], (d) => (d.items?.length ?? 0) === 0);
  return (
    <ApiResourceView
      resource={res}
      empty={{ title: "No gigs yet", detail: "Create an event brief or a booking to start preparing." }}
      render={(data) => {
        const bookings = (data.items ?? []) as unknown as BookingItem[];
        return (
          <PanelShell title="Bookings">
            {bookings.map((b) => (
              <div key={b.id} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0" }}>
                <span>{b.title}{b.eventDate ? <span style={{ fontSize: 10, opacity: 0.6 }}> · {b.eventDate}</span> : null}</span>
                <Badge tone={b.status === "confirmed" || b.status === "completed" ? "ok" : b.status === "cancelled" ? "warn" : "neutral"}>{b.status}</Badge>
              </div>
            ))}
          </PanelShell>
        );
      }}
    />
  );
}
